module.exports = __webpack_public_path__ + "img/364043650.ba1e6018.jpg";